import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isSuperAdmin } from '../../utils/userRoles';

function SuperAdminRoute() {
  const { token, user, isLoadingAuth } = useAuth();

  if (isLoadingAuth) {
    return (
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <div className="text-muted">Loading super admin workspace...</div>
        </div>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/sa/login" replace />;
  }

  if (!isSuperAdmin(user)) {
    return <Navigate to="/sa/login" replace />;
  }

  return <Outlet />;
}

export default SuperAdminRoute;
